import { render, staticRenderFns } from "./TransportadoraTpCalcExtrairForm.vue?vue&type=template&id=cf582aca"
import script from "./TransportadoraTpCalcExtrairForm.vue?vue&type=script&lang=js"
export * from "./TransportadoraTpCalcExtrairForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports